// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/*!\n * My.css\n */\n \n \n.container-cust {\n    width: 100% !important;\n    max-width: 960px !important;\n    padding: 0 10px !important;\n} \n \na {\n    color: #000;\n    text-decoration: none;\n    background-color: transparent;\n}\na:hover {\n    color: #f16e00;\n    text-decoration: none;\n}\n \n \n \n \n \n \n \n \n/**/", ""]);
// Exports
module.exports = exports;
